export const PRESENTER = "PRESENTER";
export const CRUD = "CRUD";
export const DELETE_PRESENTER = "DELETE_PRESENTER";
export const ADD_PRESENTER = "ADD_PRESENTER";
export const CHANGE_PRESENTER = "CHANGE_PRESENTER";
export const UPDATE_EVENT_CRUD = "UPDATE_EVENT_CRUD";
export const UPDATE_FREE_CLASS_CRUD = "UPDATE_FREE_CLASS_CRUD";
export const CHANGE_INSTRUCTOR = "CHANGE_INSTRUCTOR";
export const DELETE_INSTRUCTOR = "DELETE_INSTRUCTOR";
export const ADD_INSTRUCTOR = "ADD_INSTRUCTOR";
